export const CleanStripeSubscriptionStatus = {
  incomplete: 'incomplete',
  incomplete_expired: 'incomplete_expired',
  trialing: 'trialing',
  active: 'active',
  past_due: 'past_due',
  canceled: 'canceled',
  unpaid: 'unpaid'
} as const

export type CleanStripeSubscriptionStatus =
  (typeof CleanStripeSubscriptionStatus)[keyof typeof CleanStripeSubscriptionStatus]


